module.exports = __webpack_public_path__ + "static/media/RemoveAssociationIcon.9b7ec92b.svg";